import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';

export const useLightWeightPackageInfo = () => useQuery(queries.accounts.lightWeightPackageInfo);
